import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { HdPhsInfoService } from '@/app/human-design/chart/bodygraph/hd-phs-info.service';
import { PhsCategory } from '@/app/human-design/chart/bodygraph/hd-phs-metadata';

/**
 * PHS / Rave-Psychologie cheat sheet — het volledige Figma-design (node 2908:2) als vier
 * gestapelde transformatie-banden (Vertering · Omgeving · Bewustzijn · Perspectief), met de
 * vastgelegde FA-iconen als enige toevoeging. Controls-bar met taalswitcher + print, analoog
 * aan de andere cheat sheets. Print-vaste A3-landscape. Vervangt de vroegere 2×2-cheat-sheet.
 */
@Component({
  selector: 'hd-phs-transformation-cheat-sheet-page',
  standalone: false,
  templateUrl: './hd-phs-transformation-cheat-sheet-page.component.html',
  styleUrl: './hd-phs-transformation-cheat-sheet-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdPhsTransformationCheatSheetPageComponent {
  private readonly phsInfo = inject(HdPhsInfoService);

  /** De vier transformatie-banden, top → bottom (zoals het Figma-design). */
  protected readonly bands: readonly PhsCategory[] = ['determination', 'environment', 'motivation', 'view'];

  constructor() {
    // Tweetalig (primaire content-taal + gloss): beide scope-talen laden.
    this.phsInfo.loadScopesForLang('nl');
    this.phsInfo.loadScopesForLang('en');
  }

  protected print(): void {
    window.print();
  }
}
